/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/plan': {
    width: 29,
    height: 29,
    viewBox: '0 0 29 29',
    data: '<path pid="0" d="M21.802 22h-3.46l-1.374-3.577h-6.295L9.373 22H6l6.134-15.748h3.362L21.802 22zm-5.855-6.23l-2.17-5.844-2.127 5.844h4.297z" _fill="#000"/><path pid="1" _stroke="#000" d="M.5.5h28v28H.5z"/>'
  }
})
